var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframeModule"},[_c('iframe',{attrs:{"id":"iframe","name":"ifrmname","frameborder":"0","src":false}})])
}
var staticRenderFns = []

export { render, staticRenderFns }